import React, { SVGProps } from 'react'

const SmallCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    fill="none"
    {...props}
  >
    <path
      fill="#3B3B3B"
      d="m9.634.26 1.105 1.105L6.604 5.5l4.135 4.135-1.105 1.105L5.5 6.605 1.364 10.74.26 9.635 4.395 5.5.259 1.365 1.364.26 5.5 4.395 9.634.26Z"
    />
  </svg>
)

export default SmallCloseIcon
